"use client";

import React, { useState } from "react";
//import Link from 'next/link';
import { ArrowLeft } from "lucide-react";
//import Image from 'next/image';
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "../../components/ui/dialog";
import brokerImage from "../../assets/images/settings/broker.svg";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";

const BecomeABroker = () => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white">
          <ArrowLeft
            className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20"
            onClick={() => {
              navigate("/settings/index");
            }}
          />
          <p className="text-sm font-medium underline mr-2">Settings</p>
          <p className="text-sm font-medium"> / Become a Broker</p>
        </div>

        {/* Main Content */}
        <div className="flex justify-center mt-16 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full bg-white rounded-2xl shadow-lg p-10 flex flex-col items-center">
            {/* Icon */}
            <img
              src={brokerImage}
              alt="Become a Broker"
              width={100}
              height={100}
              className="mb-6"
            />

            {/* Title and Description */}
            <h2 className="text-xl font-semibold text-gray-800 text-center mb-4">
              Suit up
            </h2>
            <p className="text-sm text-gray-600 text-center mb-8">
              Become an 80Eight broker to access exclusive benefits and
              resources.
            </p>

            {/* Buttons */}
            <div className="flex space-x-4">
              <Button
                variant="outline"
                className="px-6 font-semibold py-2 rounded-full"
                onClick={() => {
                  navigate("/support/faqs");
                }}
              >
                Learn more
              </Button>

              <Button
                className="bg-gradient-to-r from-pink-500 to-purple-500 text-white px-6 py-2 font-semibold rounded-full"
                onClick={() => setOpenDialog(true)}
              >
                Apply now
              </Button>
            </div>
          </div>
        </div>

        {/* Popup Modal */}
        <Dialog open={openDialog} onOpenChange={setOpenDialog}>
          <DialogContent className="max-w-lg p-6 rounded-2xl">
            <DialogHeader>
              {/* Icon in the Modal */}
              <div className="flex justify-center mb-4">
                <img
                  src={brokerImage}
                  alt="Become a Broker"
                  width={100}
                  height={100}
                  className="mb-2"
                />
              </div>
              <DialogTitle className="text-lg font-semibold text-gray-800 text-center">
                Thank you!
              </DialogTitle>
              <DialogDescription className="text-gray-600 text-center">
                Thanks for showing interest in becoming a broker with 80Eight.
                We’ll be reaching out to you to discuss the details.
              </DialogDescription>
            </DialogHeader>
            <div className="flex justify-center pt-6">
              <DialogClose className="px-6 py-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full">
                Close
              </DialogClose>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default BecomeABroker;
